import "../styles/AdminInterface.css"
/* import "../styles/App.css"
 */import React, { useState, useEffect, useRef } from 'react'
import BackendAPI from "../API/BackendAPI"
import IconButton from '@mui/material/IconButton';

import { useHistory } from 'react-router-dom';
import { TextField, FormControl, FormControlLabel, Checkbox, InputLabel, Divider, Typography, TableContainer, TableHead, TableRow, Paper, TableBody, Table, TableCell, Select, MenuItem } from "@material-ui/core"
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import DownloadIcon from '@mui/icons-material/Download';
import Tooltip from '@mui/material/Tooltip';
import { telechargerCSV, aujourdhui } from "../utils/csv"

import Popup from "../components/Popup"
import Sidebar from "../components/Sidebar"
import cookie from 'react-cookies'


const AdminEtudiants = () => {
  // console.log("admin")
  const history = useHistory()


  const user = cookie.load("user")
  // console.log(user)
  const handleDisconnect = () => {
    // console.log("handleDisconnect")
    cookie.save('user', "disconnected", {
      path: '/',
      maxAge: 60 * 60 * 1.5, //sec
    })
    history.push('/login');
  }


  if (user === null || user === undefined || user == "disconnected") history.push("/login");
  if (user !== null && user !== undefined && user.username !== undefined && !user.username.toUpperCase().includes("ADMIN")) handleDisconnect()


  // const [actualiser,setActualiser]=useState(true)
  
  const [popupText,setPopupText]=useState(null)

  const [users, setUsers] = useState(null)
  const [localUsers, setLocalUsers] = useState(users);
  const [popupUser,setPopupUser]=useState(null)
  const [newUser,setNewUser]=useState(null)

  // Liste de référence Campus → Programme → Groupe (page Groupes), la même
  // que celle proposée aux étudiants dans l'application.
  const [groupes, setGroupes] = useState([])
  const [groupesErreur, setGroupesErreur] = useState(false)   // liste illisible (≠ liste vide)
  const [groupesCharges, setGroupesCharges] = useState(false) // rien n'est marqué « hors liste » avant
  const [incompletsSeuls, setIncompletsSeuls] = useState(false)
  const [erreurEtudiants, setErreurEtudiants] = useState(false)
  const [creationEnCours, setCreationEnCours] = useState(false)
  // Dernière valeur enregistrée de chaque champ texte (« id|champ ») : un
  // champ quitté sans modification n'est plus renvoyé au serveur.
  const valeursServeurRef = useRef({})
  const chargementEtudiantsRef = useRef(0)

  const chargerGroupes = async () => {
    const liste = await BackendAPI.getGroupes()
    setGroupesErreur(liste === null)
    if (liste !== null) {
      setGroupes(liste)
      setGroupesCharges(true)
    }
  }

  useEffect(() => {
    chargerGroupes()
  }, [])



  useEffect(()=>{
    if(users==null){
      clickActualiser()
    }
    setLocalUsers(users)
  },[users])


  const clickActualiser = async () => {
    // Seule la dernière demande compte (deux rechargements rapprochés).
    const numero = ++chargementEtudiantsRef.current
    const liste = await BackendAPI.getEtudiants()
    if (numero !== chargementEtudiantsRef.current) return
    if (liste === null) {   // serveur injoignable : message au lieu d'une page blanche
      setErreurEtudiants(true)
      return
    }
    setErreurEtudiants(false)
    valeursServeurRef.current = {}
    setUsers(liste)
  }
  
  const updateServer =async(event,field,id) => {
    event.preventDefault()
    var value="false"
    if(field!=="actif"){
      value=event.target.value
    }
    if(field=="email"){
      value=value.toLowerCase()
    }
    const cle = id + "|" + field
    const origine = (users || []).find((u) => u.id === id)
    const serveur = cle in valeursServeurRef.current ? valeursServeurRef.current[cle] : (origine ? origine[field] : undefined)
    if (field !== "actif" && String(value ?? "") === String(serveur ?? "")) return   // inchangé
    valeursServeurRef.current[cle] = value
    let ok = false
    try {
      const response = await BackendAPI.updateEtudiant(value,field,id)
      ok = !!(response && response.ok)
    } catch (e) { ok = false }
    if (!ok) {
      delete valeursServeurRef.current[cle]
      alert("La modification n'a pas été enregistrée (serveur injoignable). Réessayez.")
    }
  }
  
  const handleClicNewUser=async()=>{
    if (creationEnCours) return   // double clic : une seule création
    setCreationEnCours(true)
    let res = null
    try {
      const response = await BackendAPI.createUser(newUser)
      res = await response.json()
    } catch (e) { res = null }
    setCreationEnCours(false)
    if (!res || res.ok !== true) {
      alert("L'étudiant n'a pas été créé (e-mail manquant ou serveur injoignable). Réessayez.")
      return
    }
    if (res.doublon) alert("Un étudiant actif utilise déjà cet e-mail : il n'a pas été créé une deuxième fois.")
    setNewUser(null)
    clickActualiser()
  }

  const handleChangeUser = (event, field, id) => {
    // setActualiser(true)
    const newValue = event.target.value;

    // Crée une nouvelle liste d'utilisateurs avec les modifications apportées
    const updatedUsers = localUsers.map(user =>
      user.id === id
        ? { ...user, [field]: newValue }
        : user
    );

    // Met à jour l'état avec la nouvelle liste d'utilisateurs
    setLocalUsers(updatedUsers);
  };

  const handleChangeNewUser = (event, field) => {
    const newValue = event.target.value;
    const user = {
      ...newUser,
      [field]: field !== "email" ? newValue : newValue.toLowerCase()
    };
    setNewUser(user);
  };
  const handleKeyDown =  (event,field,id)=> {
    if (event.key === 'Enter') {
      event.preventDefault();
      event.target.blur();   // enregistrement par handleBlur (une seule requête)
    }
  };

  const handleBlur =  (event,field,id)=> {
    updateServer(event,field,id);
  };

  const handleClicDelete=(u)=>{
    const popupText= <Typography>
    Souhaitez-vous confirmer la suppression de l'utilisateur suivant ?
    <br />
    {u.nom} {u.prenom} - {u.email} - {u.campus} - {u.programme} - {u.groupe}
</Typography>
    setPopupUser(u)
    setPopupText(popupText)
  }

  // ── Campus → Programme → Groupe ──────────────────────────────
  const CHAMPS_GROUPE = ["campus", "programme", "groupe"]
  const LIBELLES_GROUPE = { campus: "Campus", programme: "Programme", groupe: "Groupe" }
  const net = (v) => (v == null ? "" : String(v).trim())
  // MySQL compare sans tenir compte de la casse : on fait pareil.
  // La base ne distingue ni majuscules ni accents (« Grande Ecole » = « Grande École »).
  const cleTexte = (v) => net(v).normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
  const egal = (a, b) => cleTexte(a) === cleTexte(b)
  // Doublons de casse (« Paris » / « PARIS ») présentés une seule fois, comme dans l'app.
  const trier = (liste) => {
    const vus = new Set()
    return liste.map(net).filter((v) => {
      const cle = cleTexte(v)
      if (!cle || vus.has(cle)) return false
      vus.add(cle)
      return true
    }).sort((a, b) => a.localeCompare(b))
  }

  const optionsPour = (champ, u) => {
    if (champ === "campus") return trier(groupes.map((g) => g.campus))
    if (champ === "programme") return trier(groupes.filter((g) => egal(g.campus, u?.campus)).map((g) => g.programme))
    return trier(groupes.filter((g) => egal(g.campus, u?.campus) && egal(g.programme, u?.programme)).map((g) => g.groupe))
  }

  // L'étudiant est-il rattaché à un groupe de la liste ?
  const groupeValide = (u) =>
    groupes.some((g) => egal(g.campus, u.campus) && egal(g.programme, u.programme) && egal(g.groupe, u.groupe))

  // Nouvelle valeur d'un champ ; les champs suivants qui n'existent pas sous
  // ce choix sont vidés (ou remplis d'office s'il n'y a qu'une possibilité).
  const cascade = (u, champ, valeur) => {
    const res = { ...u, [champ]: valeur }
    for (const enfant of CHAMPS_GROUPE.slice(CHAMPS_GROUPE.indexOf(champ) + 1)) {
      const options = optionsPour(enfant, res)
      if (!options.some((o) => egal(o, res[enfant]))) res[enfant] = options.length === 1 ? options[0] : ""
    }
    return res
  }

  // Enregistrement immédiat, en une seule requête pour les 3 champs.
  const changerGroupeEtudiant = async (u, champ, valeur) => {
    const maj = cascade(u, champ, valeur)
    const toupdate = CHAMPS_GROUPE
      .filter((c) => net(maj[c]) !== net(u[c]))
      .map((c) => ({ field: c, value: net(maj[c]) }))
    if (toupdate.length === 0) return
    setLocalUsers((ls) => ls.map((x) => (x.id === u.id ? maj : x)))
    const res = await BackendAPI.updateEtudiantChamps(u.id, toupdate)
    if (res === null) {
      alert("La modification n'a pas été enregistrée (serveur injoignable). Réessayez.")
      // On ne remet que ces 3 champs, et seulement s'ils n'ont pas changé
      // depuis (une autre modification a pu être faite entre-temps).
      setLocalUsers((ls) => ls.map((x) => (x.id === u.id && CHAMPS_GROUPE.every((c) => net(x[c]) === net(maj[c]))
        ? { ...x, campus: u.campus, programme: u.programme, groupe: u.groupe }
        : x)))
    }
  }

  const renderChoices = (champ, u, nouveau = false) => {
    const val = net(u?.[champ])
    const options = optionsPour(champ, u)
    // Valeur actuelle absente de la liste (ancienne saisie, groupe retiré…) :
    // elle reste affichée, en rouge, pour que l'administrateur la corrige.
    const absente = val !== "" && !options.includes(val)
    const horsListe = groupesCharges && val !== "" && !options.some((o) => egal(o, val))
    const parentVide = (champ !== "campus" && !net(u?.campus)) || (champ === "groupe" && !net(u?.programme))
    const libelle = LIBELLES_GROUPE[champ]
    return (
      <FormControl variant="outlined" size="small" style={{ width: "100%" }} error={horsListe}>
        {nouveau ? <InputLabel>{libelle}</InputLabel> : null}
        <Select
          value={val}
          label={nouveau ? libelle : undefined}
          disabled={parentVide || (options.length === 0 && !absente)}
          onChange={(e) => (nouveau
            ? setNewUser(cascade(newUser || {}, champ, e.target.value))
            : changerGroupeEtudiant(u, champ, e.target.value))}
        >
          {absente ? <MenuItem value={val} disabled><em>{val}{horsListe ? " (hors liste)" : ""}</em></MenuItem> : null}
          {options.map((o) => <MenuItem key={o} value={o}>{o}</MenuItem>)}
        </Select>
      </FormControl>
    )
  }

  const renderUsers = () => {
    if (Array.isArray(localUsers)) {
      return (
        <TableContainer component={Paper} style={{ maxHeight: "100%" }} >
          <Table  stickyHeader aria-label="customized table">
            <TableHead>
              <TableRow >
                {/* <TableCell align="center">Id</TableCell> */}

                <TableCell align="center" style={{ width: 150 }}>Nom</TableCell>
                <TableCell align="center"  style={{ width: 150 }}>Prénom</TableCell>
                <TableCell align="center"  style={{ width: 150 }}>Email</TableCell>

                <TableCell align="center"  style={{ width: 150 }}>Pseudo</TableCell>
                <TableCell align="center"  style={{ width: 150 }}>Campus</TableCell>
                <TableCell align="center"  style={{ width: 150 }}>Programme</TableCell>
                <TableCell align="center"  style={{ width: 150 }}>Groupe</TableCell>
                <TableCell align="center"  style={{ width: 50 }}>
                {/* <Button
          variant="contained"
          style={{padding:4}}
          className=""
          color={"primary"}
          disabled={!actualiser}
        >
          {"Actualiser"}
        </Button> */}

                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {localUsers.filter((u) => !incompletsSeuls || !groupeValide(u)).map((u) => (
                <TableRow key={u.id} style={{height:10}}>
                  {/* <TableCell align="center">{u.id}</TableCell> */}
                  <TableCell align="center" style={{ width: 150 }}> <TextField
                  value={u.nom}
                  onChange={ (e)=>handleChangeUser(e,"nom",u.id)}
                  onKeyDown={ (e)=>handleKeyDown(e,"nom",u.id)}
                  onBlur={ (e)=>handleBlur(e,"nom",u.id)}
                  variant="outlined"
                  size="small"
                /></TableCell>
                  <TableCell align="center"style={{ width: 150 }}> <TextField
                  value={u.prenom}
                  onChange={ (e)=>handleChangeUser(e,"prenom",u.id)}
                  onKeyDown={ (e)=>handleKeyDown(e,"prenom",u.id)}
                  onBlur={ (e)=>handleBlur(e,"prenom",u.id)}
                  variant="outlined"
                  size="small"
                /></TableCell>
                <TableCell align="center" style={{ width: 300 }}> <TextField
                  value={u.email}
                  onChange={ (e)=>handleChangeUser(e,"email",u.id)}
                  onKeyDown={ (e)=>handleKeyDown(e,"email",u.id)}
                  onBlur={ (e)=>handleBlur(e,"email",u.id)}
                  variant="outlined"
                  size="small"
                /></TableCell>
                  <TableCell align="center"style={{ width: 150 }}> <TextField
                  value={u.pseudo}
                  onChange={ (e)=>handleChangeUser(e,"pseudo",u.id)}
                  onKeyDown={ (e)=>handleKeyDown(e,"pseudo",u.id)}
                  onBlur={ (e)=>handleBlur(e,"pseudo",u.id)}
                  variant="outlined"
                  size="small"
                /></TableCell>
                <TableCell align="center"style={{ width: 150 }}>
                  {renderChoices("campus",u)}
                </TableCell>
                <TableCell align="center"style={{ width: 150 }}>
                  {renderChoices("programme",u)}
                </TableCell>
                <TableCell align="center"style={{ width: 150 }}>
                  {renderChoices("groupe",u)}
                </TableCell>
                <TableCell align="center"  style={{ width: 50 }}>
                  <IconButton aria-label="delete" >
                    <DeleteIcon color="primary" onClick={(e)=>{
                      handleClicDelete(u)
                      // handleBlur(e,"actif",u.id)
                    }}/>
                  </IconButton>
                </TableCell>
                </TableRow>
              ))} 

              {renderNewUser()}     
            </TableBody>
          </Table>
        </TableContainer>)
    }

    return null

  }

  const renderNewUser = () => {

    // Campus, programme et groupe obligatoires dès que la liste des groupes existe.
    var disabled = !newUser || !net(newUser.nom) || !net(newUser.prenom) || !net(newUser.email)
      || groupesErreur || (groupes.length > 0 && !groupeValide(newUser))


      return (
         <TableRow key={"NEW USER"}>
                  <TableCell align="center" style={{ width: 150 }}> <TextField
                  label="Nom"
                  value={newUser!=null? newUser.nom : ''}
                  onChange={ (e)=>handleChangeNewUser(e,"nom")}
                  // onKeyDown={ (e)=>handleKeyDown(e,"nom",u.id)}
                  // onBlur={ (e)=>handleBlur(e,"nom",u.id)}
                  variant="outlined"
                  size="small"
                /></TableCell>
                  <TableCell align="center" style={{ width: 150 }}> <TextField
                  label="Prénom"
                  value={newUser!=null? newUser.prenom : ''}
                  onChange={ (e)=>handleChangeNewUser(e,"prenom")}
                  // onKeyDown={ (e)=>handleKeyDown(e,"prenom",u.id)}
                  // onBlur={ (e)=>handleBlur(e,"prenom",u.id)}
                  variant="outlined"
                  size="small"
                /></TableCell>
                <TableCell align="center" style={{ width: 300 }}> <TextField
                  placeholder="Email"
                  value={newUser!=null? newUser.email : ''}
                  onChange={ (e)=>handleChangeNewUser(e,"email")}
                  // onKeyDown={ (e)=>handleKeyDown(e,"email",u.id)}
                  // onBlur={ (e)=>handleBlur(e,"email",u.id)}
                  variant="outlined"
                  label="Email"
                  size="small"
                /></TableCell>
                  <TableCell align="center" style={{ width: 150 }}> <TextField
                  label="Pseudo"
                  value={newUser!=null? newUser.pseudo : ''}
                  onChange={ (e)=>handleChangeNewUser(e,"pseudo")}
                  // onChange={ (e)=>handleChangeUser(e,"pseudo",u.id)}
                  // onKeyDown={ (e)=>handleKeyDown(e,"pseudo",u.id)}
                  // onBlur={ (e)=>handleBlur(e,"pseudo",u.id)}
                  variant="outlined"
                  size="small"
                /></TableCell>
                <TableCell align="center" style={{ width: 150 }}> 
                  {renderChoices("campus",newUser,true)}
                </TableCell>
                <TableCell align="center" style={{ width: 150 }}>
                  {renderChoices("programme",newUser,true)}
                </TableCell>
                <TableCell align="center" style={{ width: 150 }}>
                  {renderChoices("groupe",newUser,true)}
                </TableCell>
                <TableCell align="center" style={{ width: 50 }}>
                  <IconButton aria-label="ajouter" disabled={disabled || creationEnCours} onClick={handleClicNewUser}>
                    <AddIcon color={disabled || creationEnCours ? "disabled" : "secondary"} />
                  </IconButton>
                </TableCell>
                </TableRow> )
    }


  // Export CSV de la liste affichée (même format que les autres exports).
  const exportEtudiantsCSV = () => {
    const affiches = Array.isArray(localUsers) ? localUsers.filter((u) => !incompletsSeuls || !groupeValide(u)) : []
    if (affiches.length === 0) {
      alert("Aucun étudiant à exporter !")
      return
    }
    const entetes = ["Nom", "Prénom", "Email", "Pseudo", "Campus", "Programme", "Groupe"]
    const lignes = [...affiches]
      .sort((a, b) =>
        String(a.nom).localeCompare(String(b.nom)) ||
        String(a.prenom).localeCompare(String(b.prenom)))
      .map((u) => [u.nom, u.prenom, u.email, u.pseudo, u.campus, u.programme, u.groupe].map((v) => (v == null ? "" : String(v).trim())))
    telechargerCSV("Etudiants - " + aujourdhui() + ".csv", entetes, lignes)
  }

  // Étudiants sans groupe de la liste : l'application leur demande de le
  // choisir à leur prochaine ouverture. Filtre pour les retrouver ici.
  const renderBilanGroupes = () => {
    if (erreurEtudiants) {
      return (
        <Typography color="error" style={{ marginTop: 10 }}>
          La liste des étudiants n'a pas pu être chargée (serveur injoignable).{" "}
          <span style={{ textDecoration: "underline", cursor: "pointer" }} onClick={clickActualiser}>Réessayer</span>
        </Typography>
      )
    }
    if (!Array.isArray(localUsers)) return null
    if (groupesErreur) {
      return (
        <Typography color="error" style={{ marginTop: 10 }}>
          La liste des groupes n'a pas pu être chargée (serveur injoignable).{" "}
          <span style={{ textDecoration: "underline", cursor: "pointer" }} onClick={chargerGroupes}>Réessayer</span>
        </Typography>
      )
    }
    if (!groupesCharges) {
      return <Typography variant="body2" color="textSecondary" style={{ marginTop: 10 }}>Chargement de la liste des groupes…</Typography>
    }
    if (groupes.length === 0) {
      return (
        <Typography color="error" style={{ marginTop: 10 }}>
          Aucun groupe n'est défini : ajoutez-les dans la page Groupes pour pouvoir choisir le campus, le programme et le groupe.
        </Typography>
      )
    }
    const nb = localUsers.filter((u) => !groupeValide(u)).length
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 20, marginTop: 10 }}>
        <Typography variant="body2" color={nb > 0 ? "error" : "textSecondary"}>
          {nb === 0
            ? "Tous les étudiants sont rattachés à un groupe de la liste."
            : `${nb} étudiant${nb > 1 ? "s" : ""} sans groupe de la liste : l'application leur demandera de le choisir à leur prochaine ouverture.`}
        </Typography>
        {nb > 0 || incompletsSeuls ?
          <FormControlLabel
            style={{ width: "auto" }}
            control={<Checkbox checked={incompletsSeuls} onChange={(e) => setIncompletsSeuls(e.target.checked)} color="primary" size="small" />}
            label={<Typography variant="body2">Afficher uniquement ceux-là</Typography>}
          />
          : null}
      </div>
    )
  }

  const handleClosePopup=async(choix)=>{
    
    switch (choix) {
      case 'Supprimer Utilisateur':
        console.log(popupUser.id)
        // setActualiser(true)
        await BackendAPI.updateEtudiant("false","actif",popupUser.id)
        setPopupUser(null)
        setUsers(null)
    }

    setPopupText(null)
  }


  

  return (
    <div style={{ display: 'flex' }}>
      <Sidebar />
      <div 
      className="body-admin"
    >
      {/* Le titre (thème) a 20 px de marge en haut et 5 px en bas : les 15 px
          d'écart passent sur la ligne, sinon l'icône se centrait 7 px trop haut. */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, paddingTop: 15 }}>
        <Typography variant="h1" color="primary" style={{ paddingTop: 5 }}>Gestion des étudiants</Typography>
        <Tooltip title="Exporter les étudiants (CSV)" arrow>
          <IconButton aria-label="export etudiants" style={{ padding: 10 }} onClick={exportEtudiantsCSV}>
            <DownloadIcon />
          </IconButton>
        </Tooltip>
      </div>
      <Divider />
      {
        popupText!=null ?
        <Popup open={true} text={popupText} reponse={"Supprimer Utilisateur"} handleClose={handleClosePopup} ></Popup>
        :
        null
      }
             <div style={{margin:10}}  >
{/*           <Typography variant="h5" color="primary">Liste d'étudiants</Typography>
 */}          {renderBilanGroupes()}
          <br></br>

          {renderUsers()}

        {/*   <br></br>
          <Typography variant="h5" color="primary">Créer un nouvel étudiant</Typography>

          {renderNewUser()} */}
          {/* {newUser.nom} {newUser.prenom} {newUser.email} ({newUser.campus} - {newUser.groupe}) */}
        </div>
            


      {/* </div> */}

    </div></div>
  );
}

export default AdminEtudiants;

